module.exports = __webpack_public_path__ + "img/customer_num.42f81998.png";